import { createSelector } from 'reselect'

import { getCount } from 'partner360/features/landing/helpers/getCount'

import { selectLandingProcessesByOffering } from './selectLandingProcessesByOffering'
import { selectLandingState } from './selectLandingState'

export const selectPartnersCountInStatus = createSelector(
  [selectLandingState, selectLandingProcessesByOffering],
  ({ selectedPlanning, processedPlannings, selectedCategory }) => {
    return selectedPlanning.AllStatuses.split(',').reduce((acc, status) => {
      const categoryData = selectedPlanning.AllCategories.find(
        (el) => el.Category === selectedCategory
      )
      const offeringsForCategory = categoryData
        ? categoryData.Offerings.map((el) => el.Offering)
        : []

      return {
        ...acc,
        [status]: getCount(
          processedPlannings.filter(
            (el) =>
              el.planningId === selectedPlanning.PlanningId &&
              el.status === status &&
              el.category === selectedCategory &&
              offeringsForCategory.includes(el.offering)
          )
        ),
      }
    }, {})
  }
)
